<div class="gcc-datepicker form-control clickable d-flex align-items-center" [ngClass]="{ open: picker?.isOpen }">
  <ng-container [ngSwitch]="empty">
    <span class="flex-grow-1 note text-gray" *ngSwitchCase="true">{{ placeholder }}</span>
    <span class="flex-grow-1 note" *ngSwitchCase="false">{{ viewValue }}</span>
  </ng-container>
  <i class="icon icon-calender text-gray"></i>
</div>
